<template>
  <div class="center">
    <div class="current">
      <div class="big-title">
        <p>经营现状</p>
      </div>
      <div class="current-box">
        <h3>
          {{ currentList[currentIndex].desc }}
        </h3>
        <div class="item">
          <h4>外部</h4>
          <p
            v-for="(item, index) in currentList"
            :key="item.id"
            v-show="index < 2"
            @touchstart="chooseCurrent(item.id)"
            :class="{ active: item.id == currentIndex }"
          >
            {{ item.title }}
          </p>
        </div>
        <div class="item">
          <h4>内部</h4>
          <p
            v-for="(item, index) in currentList"
            :key="item.id"
            v-show="index >= 2"
            @touchstart="chooseCurrent(item.id)"
            :class="{ active: item.id == currentIndex }"
          >
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
    <div class="issue">
      <div class="big-title">
        <p>急需解决问题</p>
      </div>
      <div class="issue-box">
        <div class="drop-down" v-for="item in issueList" :key="item.id">
          <div
            class="issue-item"
            :class="{ active: item.id == issueIndex }"
            @touchstart="openIssue(item.id)"
          >
            <img class="icon" :src="item.img" />
            <p>{{ item.title }}</p>
            <div class="img-box">
              <img v-show="item.id != issueIndex" :src="openImg.open" />
              <img v-show="item.id == issueIndex" :src="openImg.close" />
            </div>
          </div>
          <div class="desc" v-show="item.id == issueIndex">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="program">
      <div class="big-title">
        <p>智慧地产生态链解决方案</p>
      </div>
      <div class="program-box">
        <p>
          建造业务一体化ERP平台由前台项目管理系统与渠道风控系统，中台渠道管理系统与人员管理系统，后台财务一体化构成，三者之间实现“架构可互操作、数据融合一体、流程线上贯通”，组成一体化的智慧地产生态链解决方案。
        </p>
        <img src="../../static/images/product/biaodan.png" />
        <div class="tab-nav">
          <div v-for="item in navList" :key="item.id">
            <div class="nav-item">
              {{ item.title }}
            </div>
            <div class="child" v-if="item.child && item.child.length">
              <div
                class="child-item"
                v-for="s_item in item.child"
                :key="s_item.id"
              >
                {{ s_item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="select">
      <div class="big-title">
        <p>选择过程</p>
      </div>
      <div class="select-box">
        <div class="small-title">产品差异化</div>
        <div
          class="product-item"
          v-for="item in selectObj.productList"
          :key="item.id"
        >
          <img class="icon" :src="item.img" />
          <div class="product-right">
            <h2>{{ item.title }}</h2>
            <div
              class="line"
              v-for="(s_item, s_index) in item.desc"
              :key="s_index"
            >
              <img :src="selectObj.iconImg" />
              <p>{{ s_item }}</p>
            </div>
          </div>
        </div>

        <div class="d-title">产品用户体验高</div>
        <div
          class="exp-item"
          v-for="item in selectObj.expList"
          :key="'exp' + item.id"
        >
          <img :src="item.img" />
          <div class="right">
            <h2>{{ item.title }}</h2>
            <p>{{ item.desc }}</p>
          </div>
        </div>

        <div class="small-title">服务差异化</div>
        <div class="service">
          <div class="service-title">
            <h2>售后实施：培训安装、退款条款</h2>
            <p>轻流程咨询：从体验设计规划到执行 布署的一站式客户体验咨询服务</p>
          </div>
          <div class="service-content">
            <img src="../../static/images/product/m_service.png" alt="" />
            <div class="right">
              <h2>电话维护服务</h2>
              <p>专业服务工程师为您提供及时的咨询诊断及解决建议</p>
            </div>
          </div>
        </div>
        <img src="../../static/images/product/content.png" />
        <div class="d-title">售后服务</div>

        <div class="after-box">
          <div
            class="after-item"
            v-for="item in saleAfter"
            :key="'after' + item.id"
          >
            <img :src="item.img" alt="" />
            <div>
              <h2>{{ item.title }}</h2>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
        <div class="swiper-container myRow" ref="slider">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in middleList"
              :key="'middle' + item.id"
            >
              <div class="swiper-item">
                <img class="bg" :src="item.bgImg" />
                <h2>{{ item.title }}</h2>
                <div
                  class="after-line"
                  v-for="(s_item, s_index) in item.descList"
                  :key="s_index"
                >
                  <img :src="item.iconImg" alt="" />
                  <p>{{ s_item }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom-box">
          <div
            class="bottom-item"
            v-for="(item, index) in serviceList"
            :key="'ul' + item.id"
            @touchstart="closeService(item.id)"
          >
            <img v-if="enterId == item.id" :src="item.activeImg" />
            <img v-else :src="item.img" />
            <h2>{{ item.title }}</h2>

            <div
              class="ul"
              :class="{
                'mar-left': index == 0 || index == 3,
                'mar-right': index == 2 || index == 5,
              }"
              v-show="enterId == item.id"
            >
              <span
                class="li"
                v-for="(s_item, s_index) in item.descArr"
                :key="s_index"
              >
                {{ s_item }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      otherSwiper: "",
      issueIndex: -1,
      currentIndex: 0,
      enterId: 0,
      openImg: {
        open: require("../../static/images/product/xiangxia.png"),
        close: require("../../static/images/product/xiangshang.png"),
      },

      currentList: [
        {
          id: 0,
          title: "① 渠道乱象泛滥，渠道管理和拓客经营继续规范与创新",
          desc:
            "随着新兴市场竞争的激烈，各个渠道中介之间抢客、截客等纷争不断，甚至出现中介分销数据造假，严重损坏开发商的利益，渠道管理与拓客经营需要更加规范。",
        },
        {
          id: 1,
          title: "② 外拓管理失控，靠天看人和效果暗箱已成为行业常态",
          desc:
            "在具体外拓管理过程中，经常出现拓客目标不精准、团队人员变动多、外勤行为难监控、内外场协作障碍多、信息采集效率低、业绩统计耗时长等现象。",
        },
        {
          id: 2,
          title: "① 推广模式陈旧，沿袭广告流量思维，性价比日益下降",
          desc:
            "随着移动互联网的冲击，通过社交化工具寻找精准目标客户，进而病毒式传播已成为房企营销改革的方向。",
        },
        {
          id: 3,
          title: "② 案场管理粗放，转化率底下，浪费大量客户资源",
          desc:
            "高储客背后的飞单、团队协作模式的缺乏、过程管控的严重缺失致使转化率底下。要求外场与内场协同、线上与线下协同及销售与服务协同。",
        },
      ],

      issueList: [
        {
          id: 0,
          title: "新老客户判定",
          desc:
            "无法获取真正的刚需客户，对客户无法进行判定，无法提供精准服务。",
          img: require("../../static/images/product/first.png"),
        },
        {
          id: 1,
          title: "渠道截客",
          desc:
            "渠道商在案场周边或者案场内拦截自然到访客户，唆使利诱客户以渠道客户名义成交。",
          img: require("../../static/images/product/two.png"),
        },
        {
          id: 2,
          title: "内单外飞",
          desc:
            "中介渠道串通开发商行销拓客团队，或利诱其他佣金较低渠道，将客户转至高佣金渠道成交。",
          img: require("../../static/images/product/three.png"),
        },
        {
          id: 3,
          title: "联名购房判客不准",
          desc: "顾问重复接待联名客户,浪费接待时间。",
          img: require("../../static/images/product/four.png"),
        },
        {
          id: 4,
          title: "置业顾问洗客",
          desc: "内外场顾问串通洗客,额外支付佣金。",
          img: require("../../static/images/product/five.png"),
        },
        {
          id: 5,
          title: "客流分析",
          desc:
            "每日真实进店人数无法统计进店内客户性别、年龄分析，多次重复进店客户数据筛选。",
          img: require("../../static/images/product/six.png"),
        },
      ],
      navList: [
        {
          id: 0,
          title: "智慧传播",
          url: "/m_wisdomMarket/spread",
          child: [
            { id: 0, title: "线上售楼处", url: "" },
            { id: 1, title: "拓客工具包", url: "" },
            { id: 2, title: "数据分析平台", url: "" },
          ],
        },
        {
          id: 1,
          title: "智慧渠道",
          url: "/m_wisdomMarket/channel",
        },
        {
          id: 2,
          title: "智慧案场",
          url: "/m_wisdomMarket/case",
        },
        {
          id: 3,
          title: "智慧行销",
          url: "",
        },
        {
          id: 4,
          title: "智慧交易",
          url: "",
        },
      ],
      selectObj: {
        iconImg: require("../../static/images/product/sibianxing.png"),
        productList: [
          {
            id: 0,
            title: "提高工作效率与精准度",
            img: require("../../static/images/product/dunpai.png"),
            desc: [
              "减少大量手工验证工作，提升审计效率",
              "降低损失发生的可能性，提高管理效率",
              "协助审计方法的统一、共享与传承",
            ],
          },
          {
            id: 1,
            img: require("../../static/images/product/cube.png"),

            title: "提高风险把控度，异常警示减少出错",
            desc: [
              "建立有效的舞弊风险防范机制，提升舞弊管控水平",
              "实时识别异常事项，提早预判风险",
              "通过IDM身份管理平台配置应用/服务的访问权限，保证访问安全",
              "及时解决内控缺陷及风险敞口，优化管理措施",
              "有效预防及尽早发现舞弊事件的警号，大程度降低舞弊事件给企业带来的损失",
            ],
          },
        ],
        expList: [
          {
            id: 0,
            title: "简单易用",
            desc: "七大功能产品构建地产营销新生态",
            img: require("../../static/images/product/1.png"),
          },
          {
            id: 1,
            title: "创新型开发",
            desc: "基于房企客户生命全周期打造首个互动式营销、服务平台",
            img: require("../../static/images/product/2.png"),
          },
          {
            id: 2,
            title: "高质量",
            desc: "重塑房企与客户之间的连接",
            img: require("../../static/images/product/3.png"),
          },
          {
            id: 3,
            title: "资源整合",
            desc: "灵活的O2O模式，让营销模式工具引入管理功能",
            img: require("../../static/images/product/4.png"),
          },
          {
            id: 4,
            title: "高覆盖面",
            desc: "挖掘大数据时代的房地产营销新机遇",
            img: require("../../static/images/product/5.png"),
          },
          {
            id: 5,
            title: "畅快体验",
            desc: "打通线上线下体验，快速实现小投入、大产出",
            img: require("../../static/images/product/6.png"),
          },
        ],
      },
      serviceList: [
        {
          id: 0,
          img: require("../../static/images/product/middle_one.png"),
          activeImg: require("../../static/images/product/one_active.png"),
          title: "高级支持服务",
          descArr: ["现场支持", "数据处理"],
        },
        {
          id: 1,
          img: require("../../static/images/product/middle_two.png"),
          activeImg: require("../../static/images/product/two_active.png"),
          title: "标准支持服务",
          descArr: [
            "版本升级",
            "版本更新",
            "版本更新",
            "在线问答",
            "知识库",
            "在线课程",
            "故障诊断",
            "应用指导",
            "服务预约",
            "系统监控",
            "应用评估",
            "服务工具",
          ],
        },
        {
          id: 2,
          img: require("../../static/images/product/middle_three.png"),
          activeImg: require("../../static/images/product/three_active.png"),
          title: "免费服务",
          descArr: [
            "免费服务工具",
            "注册管理",
            "应用评估服务",
            "公开技术文档",
            "一匠云之家",
            "用户论坛",
            "在线公开课程",
            "Newsletter订阅",
          ],
        },
        {
          id: 3,
          img: require("../../static/images/product/middle_four.png"),
          activeImg: require("../../static/images/product/four_active.png"),
          title: "专属服务",
          descArr: ["VIP专线坐席", "VIP绿色通道", "顾问驻点"],
        },
        {
          id: 4,
          img: require("../../static/images/product/middle_five.png"),
          activeImg: require("../../static/images/product/five_active.png"),
          title: "专享服务",
          descArr: [
            "升级/迁移服务",
            "性能优化服务",
            "应用评估服务",
            "系统巡检服务",
            "系统巡检服务",
            "功能增强服务",
            "IT 代维服务",
            "IT 运维服务",
          ],
        },
        {
          id: 5,
          img: require("../../static/images/product/middle_six.png"),
          activeImg: require("../../static/images/product/six_active.png"),
          title: "云运维服务",
          descArr: ["云巡检", "云审计", "云迁移", "云课堂"],
        },
      ],
      saleAfter: [
        {
          id: 0,
          title: "专业",
          desc: "给予企业信息化全生命周期的一站式服务",
          img: require("../../static/images/product/top_one.png"),
        },
        {
          id: 1,
          title: "智能",
          desc: "智能云服务平台",
          img: require("../../static/images/product/top_two.png"),
        },
        {
          id: 2,
          title: "创新",
          desc: "创新“云+端”服务支持模式",
          img: require("../../static/images/product/top_three.png"),
        },
      ],
      middleList: [
        {
          id: 0,
          bgImg: require("../../static/images/product/after_one.png"),
          iconImg: require("../../static/images/product/sibianxing.png"),
          title: "产品支持服务",
          descList: [
            "安全稳定：故障排除与修复、智能体检、智能监控、产品补丁包",
            "持续可用：产品智能在线服务、云ERP开放平台版本升级包",
          ],
        },
        {
          id: 1,
          bgImg: require("../../static/images/product/after_two.png"),
          iconImg: require("../../static/images/product/sibianxing.png"),
          title: "应用支持服务",
          descList: [
            "系统操作咨询服务",
            "系统代操作服务",
            "用户培训服务",
            "数据价值输出服务",
            "主动巡检与诊断服务",
            "个性化知识库维护",
          ],
        },
        {
          id: 2,
          bgImg: require("../../static/images/product/after_three.png"),
          iconImg: require("../../static/images/product/sibianxing.png"),
          title: "技术类增值服务",
          descList: [
            "性能压力负载测试服务",
            "系统上云服务",
            "云托管代运维服务",
            "人工服务时间定制",
            "服务器环境迁移服务",
            "云ERP开发平台生态服务",
          ],
        },
      ],
    };
  },
  methods: {
    openIssue(id) {
      if (id != this.issueIndex) {
        this.issueIndex = id;
      }
    },
    closeService(id) {
      if (id != this.enterId) {
        this.enterId = id;
      }
    },
    chooseCurrent(id) {
      if (id != this.currentId) {
        this.currentIndex = id;
      }
    },
  },
  mounted() {
    this.otherSwiper = new Swiper(".swiper-container", {
      slidesPerView: 2,
      centeredSlides: true,
      spaceBetween: -40,

      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
};
</script>
<style lang="stylus" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  overflow: hidden;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  width: 184px !important;
  height: 238px;
  text-align: center;
  background-color: #1E2440;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  opacity: 0.7;
  transition: 300ms;
  transform: scale(0.8);
  color: #fff;

  .swiper-item {
    .after-line {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;

      img {
        width: 6px;
        height: 4px;
      }
    }
    p {
      text-align:left;
      margin-top:-5px;
      margin-left:4px;
    }

    h2 {
      font-size: 14px;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 14px;
      letter-spacing: 2px;
      margin-bottom:18px;
    }

    img.bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index:-1;
    }
  }
}

.swiper-slide-active, .swiper-slide-duplicate-active {
  transform: scale(1);
  opacity: 1;
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 19px;
    font-weight: bold;
    color: #333333;
  }
}

.current {
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  padding: 48px 0 0;

  .current-box {
    margin: 25px auto 0;
    box-sizing: border-box;
    padding: 39px 0 0;
    width: 351px;
    height: 423px;
    background: #FFFFFF;
    border: 1px solid #E1E6F0;

    h3 {
      padding: 0 28px;
      text-align: justify;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 28px;
      margin-bottom: 20px;
    }

    .item {
      margin-bottom: 20px;
      margin-left: 10px;

      p {
        padding-left: 16px;
        line-height: 43px;
        width: 329px;
        height: 43px;
        border: 1px solid #DEDEDE;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }

      p.active {
        position:relative;
        border: 1px solid #FFC000;
      }

      p.active:before {
        content: '';
        position: absolute;
        width: 3px;
        height: 43px;
        background: #FFC000;
        left:-1px;
        top:-1px;
      }

      p:nth-child(odd) {
        border-top: 0;
      }

      h4 {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        line-height: 14px;
        margin-bottom: 6px;
      }
    }
  }

  .tabs {
    display: flex;
    justify-content: center;
    margin-top: 90px;
  }
}

.issue {
  box-sizing: border-box;
  margin-top: 46px;
  width: 100%;

  .issue-box {
    margin: 25px auto 0;
    width: 351px;
    border-bottom: 1px solid #E1E6F0;

    .desc {
      padding: 40px 20px;
      border-left: 1px solid #E1E6F0;
      border-right: 1px solid #E1E6F0;
      font-size: 14px;
      color: #666666;
      line-height: 26px;
    }
  }

  .issue-item.active {
    border-bottom: 1px solid #E1E6F0;
  }

  .issue-item.active p {
    font-weight: bold;
  }

  .issue-item {
    position: relative;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    padding-left: 20px;
    width: 351px;
    height: 56px;
    background: #FFFFFF;
    border: 1px solid #E1E6F0;
    border-bottom: 0;

    img.icon {
      width: 30px;
      height: 32px;
    }

    p {
      font-size: 12px;
      font-weight: 500;
      color: #333333;
      line-height: 14px;
      margin-left: 11px;
    }

    .img-box {
      position: absolute;
      right: 10%;
      width: 120px;
      height: 100%;

      img {
        position: absolute;
        right: 10%;
        top: 50%;
        width: 13px;
        height: 8px;
      }
    }
  }
}

.program {
  margin-top: 47px;

  .program-box {
    margin: 0 auto;
    width: 351px;

    p {
      margin: 22px 0;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }

    .tab-nav {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 16px;
      margin-bottom: 21px;
    }

    .nav-item {
      margin-bottom: 21px;
      text-align: center;
      line-height: 34px;
      width: 70px;
      height: 34px;
      background: #333333;
      font-size: 12px;
      font-weight: 500;
      color: #FFFFFF;
      margin-right: 1px;
    }

    .nav-item.active {
      color: #333333;
      background: #FFC000;
    }

    .child {
      position: absolute;
      top: 80%;
      width: 100%;
      display: flex;
      font-size: 11px;
      font-weight: 500;
      color: #666666;
      line-height: 14px;
    }

    .child-item {
      margin-left: 26px;
    }
  }
}

.select {
  width: 100%;
  margin-top: 59px;

  .small-title {
    font-size: 15px;
    font-weight: 800;
    color: #333333;
    margin-top: 19px;
    margin-bottom: 23px;
  }

  .d-title {
    margin-top: 22px;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    color: #666666;
    line-height: 14px;
    margin-bottom: 16px;
  }

  .select-box {
    width: 351px;
    margin: 0 auto;
  }

  .product-item {
    display: flex;
    padding: 27px 39px 30px 6px;
    background: #FFFFFF;
    box-shadow: 0px 2px 7px 0px rgba(175, 175, 175, 0.16);
    margin-bottom: 15px;

    img.icon {
      width: 66px;
      height: 66px;
    }

    .product-right {
      margin-left: 18px;

      img {
        width: 4px;
        height: 3px;
      }
    }

    h2 {
      font-size: 12px;
      font-weight: bold;
      color: #333333;
      line-height: 14px;
      margin-bottom: 14px;
    }

    .line {
      display: flex;
      align-items: center;

      p {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 21px;
        margin-left: 5px;
      }
    }
  }

  .exp-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .right {
      margin-left: 10px;
    }

    h2 {
      font-size: 12px;
      font-weight: bold;
      color: #333333;
      line-height: 14px;
    }

    p {
      font-size: 11px;
      font-weight: 500;
      color: #666666;
      line-height: 13px;
      margin-top: 4px;
    }

    img {
      width: 62px;
      height: 62px;
    }
  }

  .service {
    box-sizing: border-box;
    padding: 22px 20px 34px;
    height: 250px;
    background: #FFFFFF;
    border: 1px solid #EDF3FC;
    box-shadow: 0px 2px 8px 0px rgba(111, 111, 111, 0.1);
    border-radius: 5px;
    margin-bottom: 23px;

    .service-title {
      text-align: center;

      h2 {
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        line-height: 14px;
      }

      p {
        margin: 12px auto 0;
        font-size: 12px;
        font-weight: 500;
        color: #999999;
        line-height: 14px;
        max-width: 230px;
      }
    }

    .service-content {
      display: flex;
      align-items: center;
      margin-top: 39px;

      .right {
        margin-left: 10px;
      }

      img {
        width: 155px;
        height: 106px;
      }

      h2 {
        position: relative;
        font-size: 14px;
        font-weight: 800;
        color: #333333;
        line-height: 14px;
        margin-bottom: 25px;
      }

      h2::before {
        content: '';
        position: absolute;
        width: 15px;
        height: 1px;
        background: #EDB50B;
        top: 25px;
      }

      p {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        line-height: 15px;
      }
    }
  }

  .after-box {
    border-bottom: 1px solid #E1E6F0;
  }

  .after-item {
    display: flex;
    align-items: center;
    padding-left: 18px;
    max-width: 351px;
    height: 59px;
    background: #FFFFFF;
    border: 1px solid #E1E6F0;
    border-bottom: 0;

    img {
      width: 40px;
      height: 40px;
    }

    h2 {
      margin-left: 10px;
      font-size: 12px;
      font-weight: 800;
      color: #333333;
      line-height: 14px;
    }

    p {
      margin-left: 10px;
      margin-top: 7px;
      font-size: 11px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 12px;
    }
  }

  .bottom-box {
    display: flex;
    position: relative;
    margin-top: 20px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .bottom-item {
    display: flex;
    width: 33%;
    flex-direction: column;
    align-items: center;
    margin-top: 28px;
    margin-bottom: 14px;

    h2 {
      font-size: 12px;
      font-weight: 800;
      color: #333333;
      line-height: 10px;
      margin-top: 5px;
    }

    .ul {
      padding: 30px 20px;
      margin-top: 18px;
      display: flex;
      flex-wrap: wrap;
      background: #FAF9F9;
      width: 375px;
    }

    .mar-left {
      margin-left: 230px;
    }

    .mar-right {
      margin-left: -230px;
    }

    .li {
      display: inline-block;
      font-size: 12px;
      font-weight: 500;
      color: #666666;
      line-height: 28px;
      margin-right: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/CraftCenter.vue